import React from 'react';
import { Box } from '@mui/material';
import type { RateModifier } from '../../../../api/types/rater-x-preset';
import {
  CommissionInput,
  DropDown,
  IrpmField,
  ScheduleRatingInput,
  Slider,
  TextField,
} from './inputHelpers';
import { ModifierTypes, isScheduleRating } from './modifierTypes';
import {
  type PrimeXProductType,
  PrimeXProductTypes,
} from '../../../../../../../../types';
import { isExcessUwProductType } from '../../../../utils';

export { ModifierTypes, isScheduleRating };

const ModifierInputFactory = (props: ModifierInputFactoryProps) => {
  const InputComponent = deriveInputType(
    props.id as ModifierTypes,
    props.productType
  );

  return (
    <Box pr={2}>
      <InputComponent {...props} />
    </Box>
  );
};

export default ModifierInputFactory;

type ModifierInputFactoryProps = {
  rules: RateModifier['rules'];
  value: RateModifier['value'];
  disabled?: boolean;
  id: string;
  ratingDetails: RateModifier['ratingDetails'];
  handleChange: (params: Partial<RateModifier>) => void;
  type: string;
  productType: PrimeXProductType;
};

const ModifierInputMap = (productType: PrimeXProductType) => ({
  [ModifierTypes.EXPERIENCE_MODIFICATION]:
    productType === PrimeXProductTypes.prime_one_us ||
    productType === PrimeXProductTypes.p250x ||
    isExcessUwProductType(productType)
      ? IrpmField
      : DropDown,
  [ModifierTypes.ASSOCIATION_CREDIT]:
    productType === PrimeXProductTypes.prime_one_us ||
    isExcessUwProductType(productType)
      ? IrpmField
      : Slider,
  [ModifierTypes.IRPM]: IrpmField,
  [ModifierTypes.ADMIN_FEE]: TextField,
  [ModifierTypes.BROKER_FEE]: TextField,
  [ModifierTypes.COMMISSION]: CommissionInput,
  [ModifierTypes.SCHEDULED_RATING]: ScheduleRatingInput,
  [ModifierTypes.LOCAL_TAX]: CommissionInput,
  [ModifierTypes.INSURANCE_PREMIUM_SURCHARGE]: CommissionInput,
  [ModifierTypes.COLLECTION_FEE]: CommissionInput,
  [ModifierTypes.RENEWAL_RATING_FACTOR]: TextField,
  [ModifierTypes.CORRECTION_FACTOR]: IrpmField,
});

export const deriveInputType = (
  type: ModifierTypes,
  productType: PrimeXProductType
) => {
  const modifierInputMap = ModifierInputMap(productType);
  if (type in modifierInputMap) {
    return modifierInputMap[type];
  }

  return React.Fragment;
};
